import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component } from 'react';
import styled from '@emotion/styled';
import sanitizeHtml from 'sanitize-html';
import SingleChoice from './SingleChoice';
import MultiChoice from './MultiChoice';
import LongText from './LongText';
import ShortText from './ShortText';
import Scale from './Scale';
import DateChoice from './DateChoice';
import LocChoice from './LocChoice';
import Cascader from './Cascader';
import Matrix from './Matrix';
import Upload from './Upload';
import Sort from './Sort';
import OptionInput from './OptionInput';
import PureDescription from '../../common/Question/PureDescription';
import ShoppingOrder from '../../common/Question/ShoppingOrder';
import { getRealName } from '@/utilities/common';
import IconFont from '@/components/common/IconFont';
import { getQuestionType } from '@/utilities/quest';
function pauseAll() {
  var self = this;
  var audios = Array.from(document.querySelectorAll('audio'));
  [].forEach.call(audios, function (i) {
    if (i !== self) {
      i.pause();
      i.currentTime = 0;
    }
  });
}
var Question = /*#__PURE__*/function (_Component) {
  _inherits(Question, _Component);
  function Question(props) {
    var _this;
    _classCallCheck(this, Question);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Question).call(this, props));
    var question = props.question,
      answers = props.answers;
    _this.state = {
      realName: getRealName({
        question: question,
        answers: answers
      }),
      refSelected: question.nameRef && answers.nameRef ? answers.nameRef.selected : []
    };
    return _this;
  }
  _createClass(Question, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var audios = Array.from(document.querySelectorAll('audio'));
      [].forEach.call(audios, function (i) {
        i.addEventListener('play', pauseAll.bind(i));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      var question = prevProps.question,
        answers = prevProps.answers;
      var name = question.name,
        nameRef = question.nameRef,
        custom = question.custom;
      if (name && (name.includes('{选项引用}') || name.includes('{xxxx}')) && nameRef && answers[nameRef] && (custom === null || custom === void 0 ? void 0 : custom.nameRandom) && (custom === null || custom === void 0 ? void 0 : custom.showNameOptionsNum)) {
        var selected = answers[nameRef].selected;
        if (selected.length !== this.state.refSelected.length) {
          this.setState({
            refSelected: selected,
            realName: getRealName({
              question: question,
              answers: answers
            })
          });
        } else {
          selected.forEach(function (id) {
            if (_this2.state.refSelected.indexOf(id) < 0) {
              _this2.setState({
                refSelected: selected,
                realName: getRealName({
                  question: question,
                  answers: answers
                })
              });
            }
          });
        }
      }
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this$props = this.props,
        no = _this$props.no,
        question = _this$props.question,
        answer = _this$props.answer,
        hideQuestionNo = _this$props.hideQuestionNo,
        showQuestionType = _this$props.showQuestionType,
        answers = _this$props.answers;
      var name = question.name,
        nameRef = question.nameRef,
        custom = question.custom;
      var nameRandom = name && (name.includes('{选项引用}') || name.includes('{xxxx}')) && nameRef && answers[nameRef] && (custom === null || custom === void 0 ? void 0 : custom.nameRandom) && (custom === null || custom === void 0 ? void 0 : custom.showNameOptionsNum);
      var label = React.createElement("div", {
        style: _objectSpread({
          display: 'inline-flex',
          whiteSpace: 'pre-line',
          wordBreak: 'normal',
          alignItems: 'flex-start',
          width: '100%'
        }, window.textDirection)
      }, !hideQuestionNo && React.createElement("p", {
        className: "number flexNone flex alignCenter",
        style: {
          marginRight: 6,
          marginTop: 1,
          fontSize: 20,
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 1.1,
          letterSpacing: 0.2,
          color: 'var(--text-color)'
        }
      }, "".concat(Math.floor(no / 10)).concat(no % 10)), question.required && React.createElement("div", {
        className: "redColor flex alignCenter justifyCenter",
        style: {
          marginRight: 6,
          fontSize: 6,
          height: 24
        }
      }, React.createElement(IconFont, {
        type: "icon-icon-test"
      })), showQuestionType && React.createElement("p", {
        className: "flexNone flex alignCenter",
        style: {
          color: 'var(--text-color)'
        }
      }, getQuestionType(question)), React.createElement("p", {
        style: {
          color: 'var(--text-color)',
          lineHeight: 1.44,
          letterSpacing: 0.2,
          fontWeight: 400,
          fontSize: 18,
          fontStretch: 'normal',
          fontStyle: 'normal',
          width: '100%'
        },
        dangerouslySetInnerHTML: {
          __html: sanitizeHtml(nameRandom ? this.state.realName : getRealName({
            question: question,
            answers: answers
          }))
        }
      }));
      var common = _objectSpread({}, this.props, {
        label: label,
        key: question.id
      });
      switch (question.type) {
        default:
          return React.createElement("p", null, JSON.stringify(this.props));
        case 'single':
        case 'singleSelect':
        case 'nonScoreSingle':
        case 'nonScoreSingleSelect':
          return React.createElement(SingleChoice, _extends({}, common, {
            displayType: question.type,
            answer: answer || {
              selected: [],
              text: '',
              type: question.type
            }
          }));
        case 'multi':
        case 'nonScoreMulti':
          return React.createElement(MultiChoice, common);
        case 'cascader':
          return React.createElement(Cascader, common);
        case 'sort':
          return React.createElement(Sort, common);
        case 'long':
        case 'fillinLong':
          return React.createElement(LongText, common);
        case 'short':
        case 'fillinShort':
          return React.createElement(ShortText, common);
        case 'scale':
          return React.createElement(Scale, common);
        case 'date':
          return React.createElement(DateChoice, common);
        case 'location':
          return React.createElement(LocChoice, common);
        case 'description':
          return React.createElement("div", {
            style: {
              padding: '40px 72px 60px 56px'
            }
          }, React.createElement(PureDescription, common));
        case 'matrix':
          return React.createElement(Matrix, common);
        case 'upload':
          return React.createElement(Upload, common);
        case 'order':
          return React.createElement(ShoppingOrder, common);
        case 'optionInput':
          return React.createElement(OptionInput, common);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(QuestionFrame, {
        id: this.props.question.id,
        style: {
          background: 'white'
        }
      }, this.renderBody());
    }
  }]);
  return Question;
}(Component);
export { Question as default };
var QuestionFrame = /*#__PURE__*/styled("section", {
  target: "e17782nv0"
})("background:var(--question-bg) !important;margin-bottom:16px;border-radius:2px;&:last-of-type{border-bottom:none;}.ant-form-item-required{white-space:nowrap;display:flex;}.ant-form-item-required::before{display:none;}.ant-form-item-label{width:100%;white-space:normal;text-align:left;font-size:18px;margin-bottom:30px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.5;letter-spacing:0.2px;color:var(--text-color);.number{height:28px;}}.ant-form-item-label label:after{content:'';}.ant-form-item{padding:40px 72px 60px 56px;border:1px solid transparent;margin-bottom:0;}.ant-form-item.ant-form-item-with-help{border:1px solid var(--text-red);}");